module.exports = __webpack_public_path__ + "img/DP001C_001.3cc93221.png";